import { BaseJsonSchema, createSchemaByBasicTypes } from "../../../helpers";

export const SovrnBidSchema: BaseJsonSchema = {
  type: "object",
  properties: {
    bidder: {
      type: "string",
      enum: ["sovrn"],
    },
    params: {
      type: "object",
      properties: {
        tagid: createSchemaByBasicTypes("string", null, {
          additionalProperties: false,
        }),
        video: {
          type: "object",
          properties: {
            api: {
              type: "array",
              items: {
                type: "number",
              },
            },
          },
          required: ["api"],
        },
      },
      required: ["tagid"],
    },
  },
  additionalProperties: false,
  required: ["bidder", "params"],
};
